// extracted by mini-css-extract-plugin
export default {"bar":"PincodeSearch_bar__OtyP+","action":"PincodeSearch_action__ThAi6"};